import Flex from "../../UI/Flex/Flex";
import Pagination from "../../UI/Pagination/Pagination";
import { menuFilterDefaultPerPageValues } from "../../utils/constants/constants";
import formatter from "../../utils/formatters/formatter";

export default function FilterValuesPagination(props) {
  const { totalCount, page, fetchFilterValues, searchValue, setPage } = props;

  if (totalCount < menuFilterDefaultPerPageValues) {
    return null;
  }

  function changePage(page) {
    fetchFilterValues(searchValue, page);
    setPage(page);
  }

  return (
    <>
      <Pagination
        totalRows={totalCount}
        showTotalRows={false}
        currentPage={page}
        position="center"
        changePage={changePage}
        lastPage={Math.ceil(totalCount / menuFilterDefaultPerPageValues)}
        maxNeighboringPages={0}
      />
      {totalCount && (
        <Flex justifyContent="center">
          Total items: {formatter(totalCount, "integer")}
        </Flex>
      )}
    </>
  );
}
